//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLocation
} from "@fortawesome/free-solid-svg-icons";

//Estilos
import './WarehouseReqSectorList.css'

/*
    Componente encargado de la vista de los sectores de depósitos disponibles.
*/
function WarehouseReqSectorList({deposito, depositoDescrp, sectorDeposito, sectorDepositoDescrp, reqSector, reqSectorSelected }) {

    return (
        <div className={`warehouseReqSectorListDiv ${!(reqSector === reqSectorSelected) ? 'inactive' : ''}`}>
                <h4 className="depositoLabel" key={reqSector}>
                    <FontAwesomeIcon icon={faLocation} />
                    {deposito}({depositoDescrp}) &nbsp;&nbsp;&nbsp;—&nbsp;&nbsp;&nbsp; {sectorDeposito}({sectorDepositoDescrp})
                </h4>
        </div>
    );
}

export default WarehouseReqSectorList;

